import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { favoriteActions } from "../../../../../store/favorite-slice"
import InfoIcon from "../../../../InfoIcon"

const Resort = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredfavorites = useSelector((state) => state.favorite.filteredFavorites)
    let favorites=useSelector(state=>state.favorite.favorites)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(favoriteActions.setFilteredItems(resort(filteredfavorites??favorites, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(favoriteActions.setFilteredItems(resort(filteredfavorites??favorites, type, 'DESC')))
        }} />
    </Fragment>
}

export default Resort